import Add from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import type { ButtonProps } from '@mui/material/Button';

interface CreateButtonProps extends Omit<ButtonProps, 'children'> {
  label: string;
  tooltipLabel?: string;
}

export default function CreateButton({
  label,
  tooltipLabel,
  ...rest
}: CreateButtonProps) {
  return (
    <Tooltip arrow title={tooltipLabel ? tooltipLabel : ''}>
      <span>
        <Button
          {...rest}
          variant="contained"
          startIcon={<Add />}
          sx={{
            textTransform: 'none',
            ml: 1,
            height: 40,
            ...rest.sx,
          }}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
}
